export const OVERRIDE_APPERANCE = {
  theme: "stripe",
  variables: {
    fontFamily: "Poppins, sans-serif",
    fontWeightBold: "900",
    fontSizeSm: "14px",
    borderRadius: "6px"
  },
  rules: {
    ".Label": {
      fontStyle: "normal",
      lineHeight: "24px",
      fontWeight: "600",
      color: "rgb(33, 37, 41)"
    },
    ".Input::placeholder": {
      fontWeight: "400 !important",
      fontFamily: "Poppins, sans-serif"
    },

    ".TermsText": {
      fontFamily: "Poppins, sans-serif",
      fontWeight: "400 !important",
      height: "42px",
      lineHeight: "21px",
      fontSize: "14px",
      color: "rgba(0, 0, 0, 0.5)"
    }
  }
};
